/* eslint-disable max-len */
import { _, am5, am5radar, am5xy } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

import { getColor } from '../../../../helpers';

export const createSeries = ({
  root,
  chart,
  data,
  labels,
  dimensions,
  xAxis,
  yAxis,
}: {
  root: am5.Root;
  chart: am5xy.XYChart;
  data: types.widgets.TableData;
  labels: types.widgets.TableData;
  dimensions: string[];
  xAxis: am5xy.CategoryAxis<am5xy.AxisRenderer>;
  yAxis: am5xy.ValueAxis<am5xy.AxisRenderer>;
}) => {
  const createSingleSeries = (dimension: string, color: am5.Color) => {
    const series = chart.series.push(
      am5radar.RadarLineSeries.new(root, {
        name: dimension,

        xAxis: xAxis,
        yAxis: yAxis,

        fill: color,
        stroke: color,

        valueYField: dimension,
        categoryXField: 'spoke',
        locationX: 0,
        locationY: 1,
      })
    );

    series.strokes.template.setAll({
      strokeWidth: 1,
    });

    const tooltip = am5.Tooltip.new(root, {
      labelText: '[bold]{categoryX}[/]: {valueY}',
    });

    tooltip.label.setAll({
      fontSize: 11,
    });

    series.set('tooltip', tooltip);

    series.on('tooltipDataItem', function (e) {
      const component = e.component;
      const tooltip = component.get('tooltip');
      const dataContext = e.dataContext;
      const obj = labels.find((item) => item.spoke == (dataContext as any).spoke);
      const spoke = _.startCase(obj['spoke'] as string);
      const values = _.omit(obj, 'spoke');
      const value = typeof values[dimension] === 'number' ? values[dimension].toFixed(2) : values[dimension];

      tooltip.set('labelText', `${spoke}: ${value}`);
    });

    series.bullets.push(function () {
      const circle = am5.Circle.new(root, {
        radius: 5,
        fill: series.get('fill'),
      });

      const bullet = am5.Bullet.new(root, {
        sprite: circle,
        locationX: 0,
        locationY: 1,
      });

      return bullet;
    });

    return series;
  };

  dimensions.forEach((dim, index) => {
    const seriesObj = createSingleSeries(dim, am5.color(getColor(index)));
    seriesObj.appear(1000);
    seriesObj.data.setAll(data);
    xAxis.data.setAll(data);
  });
};
